module.exports = __webpack_public_path__ + "5a6667e1466db64129410c6438a9ae03.png";